import { render, staticRenderFns } from "./TableLastShipSMS.vue?vue&type=template&id=73d81f1b&scoped=true&"
import script from "./TableLastShipSMS.vue?vue&type=script&lang=js&"
export * from "./TableLastShipSMS.vue?vue&type=script&lang=js&"
import style0 from "./TableLastShipSMS.vue?vue&type=style&index=0&id=73d81f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d81f1b",
  null
  
)

export default component.exports